export const Search = {
  title: 'Search.title',
  prefix: 'Search.Result.Help.prefix',
  suffix: 'Search.Result.Help.suffix',
  functionalEntry: 'Search.Result.label.functionalEntry'
};
